export const namespace = 'locationQuestion';